import moment from 'moment';

/**
 * @deprecated use RHF and YUP
 */
export function validateEmails(emails) {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  for (const idx in emails) {
    if (!emailRegex.test(emails[idx])) {
      return false;
    }
  }
  return true;
}

/**
 * @deprecated use RHF and YUP
 */
export function validatePhoneNumber(phoneNumber) {
  const phoneNumberRegex = /^0|62[0-9]{0,}$/;
  if (!phoneNumberRegex.test(phoneNumber)) {
    return false;
  }
  return true;
}

/**
 * @deprecated use RHF and YUP
 */
export function validateSingleEmail(email) {
  const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (!emailRegex.test(email)) {
    return false;
  }
  return true;
}

/**
 * @deprecated use RHF and YUP
 */
export function validateDatetimeAfterNow(date) {
  return !(date && date <= new Date());
}

/**
 * @deprecated use RHF and YUP
 */
export function validateDatetimeAfterDate(
  date,
  limit,
  equalTimeAllowed = false,
) {
  if (!equalTimeAllowed) {
    return !(date && date < limit);
  } else {
    return !(date && date <= limit);
  }
}

/**
 * @deprecated use RHF and YUP
 */
export function getStringDateTimeFromURI(dateURI) {
  const decodedDate = decodeURIComponent(dateURI).replace('+', ' ');
  const isValidDate = moment(
    decodedDate,
    'YYYY-MM-DD HH:mm:ss',
    true,
  ).isValid();

  if (isValidDate) {
    return decodedDate;
  }
}

// For format YYYY-MM-DD HH:mm:ss
/**
 * @deprecated use RHF and YUP
 */
export function validateDate(dateURI) {
  const validDate = getStringDateTimeFromURI(dateURI);
  if (validDate) {
    return true;
  }
  return false;
}

/**
 * @deprecated use RHF and YUP
 */
export const passwordRegexValidatorRule =
  'min:8|max:256|regex:/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&~]).*$/';

/**
 * @deprecated use RHF and YUP
 */
export const emailValidator = val => {
  let re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!re.test(val)) {
    re =
      // eslint-disable-next-line no-control-regex
      /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/;
  }
  return re.test(val);
};

/**
 * @deprecated use RHF and YUP
 */
export const validatorRules = {
  username: 'required|min:6|max:64|regex:/^[a-z][a-z0-9]+$/',
  brand_name:
    'required|max:128|regex:/^[a-zA-Z0-9 ]+$/|not:tokoku,Tokoku,pulsamarket,Pulsamarket,galaxyyshop101,Galaxyyshop101',
  company_name: 'max:256|regex:/^[a-zA-Z0-9 ()&.,!#_@-]+$/',
  full_name: 'required|max:64',
  email: 'required|email|max:256|regex:/^(?!\\d+@)[^@]+@[^@]+$/',
  phone_number: ['regex:/^[0-9]+$/'],
  roles: 'array',
  old_password: 'required|min:8|max:256',
  password: `required|${passwordRegexValidatorRule}`,
  verify_password: `required|${passwordRegexValidatorRule}`,
  verify_password_confirmation: 'required|same:password',
  industry: 'required|max:128',
  address: 'max:128',
  pic_phone_number: ['regex:/^(62|0)\\d*$/'], // TODO: remove this then migrate to phone_number
  pic_name: 'max:64',
  pic_email: 'email|max:255',
  date_of_incorporation: 'required',
  npwp_number: 'required',
  referral_code: 'max:64',
  ktp_number: ['required', 'regex:/^[0-9]{16}$/'],
  postal_code: ['required', 'regex:/^[0-9]{5}$/'],
  birth_place_and_date: ['required', 'regex:/[A-Za-z]+, \\d{2}/\\d{2}/\\d{4}/'],
  business_link:
    'regex:/(?:https?:\\/\\/)?(?:www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_\\+.~#?&/=]*)/i',
  country_code: 'required',
};

/**
 * @deprecated use RHF and YUP
 */
export function validateNotes(notes) {
  const regex = /^[a-zA-Z0-9 ]*$/;
  return regex.test(notes);
}
